"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PencilIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-1089.000000, -235.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "PencilIcon",
        transform: "translate(1089.000000, 235.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M16.3109565,5.9286087 L13.3866087,3.00426087 L14.2918261,2.09991304 L17.2153043,5.0233913 L16.3109565,5.9286087 Z M4.90226087,17.339913 L2.93530435,17.4546957 C2.78921739,16.9173043 2.39617391,16.5207826 1.86313043,16.3642609 L1.97878261,14.412087 L12.1570435,4.23382609 L13.0057391,5.08165217 L3.27965217,14.8077391 C2.93965217,15.1477391 2.93965217,15.6973043 3.27965217,16.0373043 C3.44921739,16.2068696 3.67182609,16.292087 3.89443478,16.292087 C4.11704348,16.292087 4.33878261,16.2068696 4.50921739,16.0373043 L14.2353043,6.31121739 L15.0813913,7.15817391 L4.90226087,17.339913 Z M19.0605217,4.40773913 L14.9074783,0.255565217 C14.744,0.0920869565 14.5222609,-8.69565216e-05 14.2918261,-8.69565216e-05 C14.0605217,-8.69565216e-05 13.8396522,0.0920869565 13.6770435,0.254695652 L0.515304348,13.4164348 C0.364869565,13.5668696 0.275304348,13.7677391 0.26226087,13.979913 L0.00139130435,18.3955652 C-0.0133913043,18.6442609 0.0787826087,18.886 0.254434783,19.0625217 C0.417913043,19.226 0.638782609,19.3164348 0.869217391,19.3164348 C0.886608696,19.3164348 0.903130435,19.3164348 0.920521739,19.3155652 L5.33443478,19.0564348 C5.5466087,19.0442609 5.74747826,18.9538261 5.89791304,18.8033913 L19.0605217,5.63817391 C19.224,5.47556522 19.3153043,5.25382609 19.3153043,5.02252174 C19.3153043,4.79208696 19.224,4.57121739 19.0605217,4.40773913 L19.0605217,4.40773913 Z",
            fillRule: "nonzero"
          })
        })
      })
    })
  })]
});

PencilIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = PencilIcon;
exports.default = _default;